var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.492,
    height: 47.415,
    viewBox: "0 0 68.492 47.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2",
    transform: "translate(-23.923 -31.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10974",
    "data-name": "Caminho 10974",
    d: "M81.313,58.01l-.184-.131-.144-.171c-.946-1.116-9.194-10.809-15.931-14.447l-.315.289c-2.509,2.259-7.171,6.449-11.82,6.8h-.184a7.788,7.788,0,0,1-5.411-3.4,3.244,3.244,0,0,1,.223-3.638h0A15.118,15.118,0,0,1,49.5,41.632c1.852-1.484,4.951-3.94,8.379-7.25-6.37-4.649-17.7,1.576-19.385.946s-2.824-1.983-4.426-2.929c-2.246-1.313-3.06.617-3.06.617L24.1,48.278a1.418,1.418,0,0,0,.788,2.036,11.636,11.636,0,0,1,5.976,4.7l3.664-3.6a4.707,4.707,0,0,1,8.025,4.058,4.7,4.7,0,0,1,6.856,4.9,4.728,4.728,0,0,1,6.882,4.873,4.728,4.728,0,0,1,5.753,7.3l-.092.105.709.709a4.15,4.15,0,0,0,5.818-5.884l.985.985A4.161,4.161,0,1,0,75.35,62.58l.985.985a4.15,4.15,0,0,0,6.567-4.82A3.94,3.94,0,0,1,81.313,58.01Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10975",
    "data-name": "Caminho 10975",
    d: "M86.444,47.926v-.105c-.158-.525-1.537-3.769-3.349-7.473-2.706-5.556-3.809-6.882-4.137-7.2H78.8c-4.124,1.615-6.567,2.364-7.565,2.364h0a8.563,8.563,0,0,1-1.156-.079,34.686,34.686,0,0,1-6.659-1.655H63.3a12.674,12.674,0,0,0-5.253-1.589h0a2.627,2.627,0,0,0-1.563.368c-.985,1.038-1.97,2.023-2.929,2.942-3.546,3.4-6.738,5.963-8.642,7.486-.788.63-1.537,1.235-1.668,1.392a1.313,1.313,0,0,0-.079,1.51,6,6,0,0,0,3.691,2.377h0c3.94-.3,8.287-4.2,10.612-6.3l.841-.749.512-.433.276.131.328.171c7.105,3.585,15.9,13.843,17.074,15.288a1.747,1.747,0,0,0,.932.407h0A.447.447,0,0,0,77.7,56.7l.092-.092s6-4.623,7.486-6.107a3.073,3.073,0,0,0,1.169-2.574Z",
    transform: "translate(5.968 0.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10976",
    "data-name": "Caminho 10976",
    d: "M38.266,48.026a2.771,2.771,0,0,0-3.94,0l-4.741,4.741a2.786,2.786,0,0,0,3.94,3.94l4.741-4.768a2.771,2.771,0,0,0,0-3.914Z",
    transform: "translate(1.518 4.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10977",
    "data-name": "Caminho 10977",
    d: "M43.486,51.756a2.771,2.771,0,0,0-3.94,0L34.8,56.5a2.786,2.786,0,0,0,3.94,3.94L43.486,55.7a2.771,2.771,0,0,0,0-3.94Z",
    transform: "translate(3.154 5.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10978",
    "data-name": "Caminho 10978",
    d: "M48.7,55.486a2.771,2.771,0,0,0-3.94,0l-4.715,4.741a2.786,2.786,0,0,0,3.94,3.94l4.807-4.82a2.771,2.771,0,0,0-.092-3.861Z",
    transform: "translate(4.796 7.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10979",
    "data-name": "Caminho 10979",
    d: "M54.756,61.149a2.771,2.771,0,0,0-4.308-2.3c-.118.066-5.253,5.109-5.253,5.109a2.786,2.786,0,1,0,3.94,3.94L54.007,63a2.758,2.758,0,0,0,.749-1.852Z",
    transform: "translate(6.41 8.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10980",
    "data-name": "Caminho 10980",
    d: "M54.131,63.079,49.389,67.82a4.715,4.715,0,0,1-1.129.827A4.137,4.137,0,0,0,54.236,63Z",
    transform: "translate(7.626 9.733)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.faa8dfb4fca0a51a852e28be4a12f2ad.svg";
export { ForwardRef as ReactComponent };